module.exports = __webpack_public_path__ + "static/img/y67.9c73e35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y67.jpg
// module id = SaKa
// module chunks = 1